import api from "./index";

export async function getWallet() {
  return api.get("/wallets/me");
}
